import { Component, OnInit } from '@angular/core';

import { Http, Response } from '@angular/http';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnInit {


  constructor(private http: Http) { }

  ngOnInit() {
  }

  newsletter(firstname, lastname, email){
    this.http.post("/",
    {
      submit:"" ,
      sp_firstname: firstname,
      sp_lastname: lastname,
      sp_email: email,
      sendpress: "post",
      sp_list: 40
    }).subscribe(
      data => {
        console.log(data)
      }
    )
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/newsletter/newsletter.component.ts